/**
 * @module lib/financial/autorefresh-control
 */
import { local } from "lib/store";
import Tooltip from "ui/Tooltip";
import { qs, getById } from "utils/utils";

let control;
let tooltip;
let tooltipText;
let timeout = 0;

/**
 * @method onChange
 * @description Toggles localStorage value for financial autorefresh control.
 */
function onChange() {
  // Store toggled checkbox value in localStorage
  const controlStatus = control.checked;
  setTooltipText(controlStatus);
  local.set("tgam.financial-autorefresh", controlStatus);
  tooltip.open();
}

/**
 * @method setTooltipText
 * @description Sets tooltip text depending on checkbox status
 * @param {Boolean} checked - value of whether or not checkbox is checked
 */
function setTooltipText(checked) {
  if (checked === true) {
    tooltipText.innerHTML = "Unchecking box will stop auto data updates";
  } else {
    tooltipText.innerHTML = "Checking box will start auto data updates";
  }
}

/**
 * @method setup
 * @description handles setting of financial autorefresh control and value globally.
 *
 */
export default function setup() {
  control = getById("js-c-realtime-control");

  if (!control) {
    return;
  }
  const tooltipTrigger = getById("js-c-realtime-tooltip-trigger");
  tooltipText = qs("#js-c-realtime-tooltip .c-tooltip__inner");
  tooltip = new Tooltip(tooltipTrigger);
  tooltip.activate();

  control.addEventListener("focus", () => {
    window.clearTimeout(timeout);
    tooltip.open();
  });
  control.addEventListener("blur", () => {
    // This timeout prevents the Tooltip from disappearing on blur, then
    // immediately reappearing on focus, when the checkbox is checked/unchecked
    window.clearTimeout(timeout);
    timeout = window.setTimeout(() => {
      tooltip.close();
    }, 1000);
  });

  let enableAutorefresh = local.get("tgam.financial-autorefresh");

  // Set the initial value of checkbox based on localStorage variable set by user.
  control.checked = enableAutorefresh === undefined || enableAutorefresh === true;
  setTooltipText(control.checked);

  control.addEventListener("change", onChange);
}
